import { createClient } from '@supabase/supabase-js';
const supabaseUrl = 'https://ggwxrbocvnivpnwxmyvc.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imdnd3hyYm9jdm5pdnBud3hteXZjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMyMzE3MzMsImV4cCI6MjA2ODgwNzczM30.cJ0nelsrh3_GSgO1NoeRoKEshaQyKzw7N06xiZY0-Ew';
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
